import { connect } from 'dva';
import React from 'react';
import { namespace } from '../model';
import { FilterBasicTime } from './filters/FilterBasicTime';

export default connect((state: any) => {
  const { filterBasic = [] } = state[namespace];
  return {
    filterBasic,
  };
})(FilterBasicCondition);

export const TIME = 0;
export const COUNTRY = 1;
function FilterBasicCondition(props: any) {
  const { filterBasic } = props;

  const dispatchFun = (payload: any) => {
    props.dispatch({
      type: `${namespace}/save`,
      ...payload,
    });
  };

  return (
    <div style={{ display: 'flex', paddingBottom: '20px' }}>
      <FilterBasicTime
        column={filterBasic[TIME]}
        onChange={(columnInfo) => {
          filterBasic[TIME] = columnInfo;
          dispatchFun({ payload: { filterBasic: [...filterBasic] } });
        }}
      />
      {/* <FilterBasicCountry*/}
      {/*  column={filterBasic[COUNTRY]}*/}
      {/*  onChange={(columnInfo) => {*/}
      {/*    filterBasic[COUNTRY] = columnInfo;*/}
      {/*    dispatchFun({ payload: { filterBasic: [...filterBasic] } });*/}
      {/*  }}*/}
      {/*/ >*/}
    </div>
  );
}
